import { usePageTitle } from '@/hooks/usePageTitle';
import { STORAGE_KEYS, useStorage } from '@/hooks/useStorage';
import { persistor } from '@/store';
import { parseJourneyChangeUrlParams } from '@/utils/journeyChangeUrlParams';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

const JourneyChange = () => {
  usePageTitle('journeyChange');
  const navigate = useNavigate();
  const { search } = useLocation();

  // Retire the whole flow once its exchange has been paid for: the selection
  // steps are still in history, and going back from `/success` would land on
  // offer select, whose Continue would commit a SECOND exchange for the
  // fulfillment just paid for. `JourneyChangeCheckout` records that fulfillment
  // in session storage; this layout re-reads it on remount (a back-navigation
  // from `/success`) and `replace`s the spent step out of history.
  const { value: paidFulfillment } = useStorage<string>(
    sessionStorage,
    STORAGE_KEYS.JOURNEY_CHANGE_PAID_FULFILLMENT
  );
  const { fulfillment } = parseJourneyChangeUrlParams(search);
  const isPaid = !!fulfillment && paidFulfillment === fulfillment;

  useEffect(() => {
    if (isPaid) navigate('/purchase', { replace: true });
  }, [isPaid, navigate]);

  if (isPaid) return null;

  // Gate on rehydration like `/purchase` does: redirect-based payments (3DS,
  // iDEAL) return to the checkout step as a fresh document load, and its
  // resume check must not run against an empty store.
  return (
    <PersistGate loading={null} persistor={persistor}>
      <Outlet />
    </PersistGate>
  );
};

export default JourneyChange;
